import type { GetServerSidePropsResult } from 'next';

export const NOT_FOUND: GetServerSidePropsResult<any> = { notFound: true };
